<template>
  <form @submit.prevent="onSearch">
    <div class="row">
      <div class="col-lg-2 col-md-6 col-sm-12">
        <input name="messageType"
               class="form-control"
               v-model="filters.messageType"
               placeholder="Message type"/>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <div v-if="statusDropdown && statusDropdown.length">
          <SelectVue
              v-model="filters.status"
              :options="statusDropdown"
              :is-clear="true"
              :placeholder="'Status'"/>
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <Datepicker
            v-model="filters.dateFrom"
            position="down"
            placeholder="Date from"/>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <Datepicker
            v-model="filters.dateTo"
            position="down"
            placeholder="Date to"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12 mt-lg-0">
        <input name="searchTerm"
               class="form-control"
               v-model="filters.searchTerm"
               placeholder="Search"/>
      </div>
      <div class="col-lg-1 col-sm-12 col-12 d-flex d-lg-block justify-content-center">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import {defineEmits, defineProps, toRefs} from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  statusDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['search']);

const {filters} = toRefs(props);

function onSearch() {
  emit('search', 1, undefined, filters.value);
}
</script>

<style scoped>
</style>
